/* eslint-disable jira/naming/disallow-filenames */

import React, { useEffect } from 'react';
import { useCurrentRoute as useCurrentRouteDI } from '@jira/platform__utils-router/src/index.tsx';
import {
	useAnalyticsEvents as useAnalyticsEventsDI,
	fireScreenAnalytics as fireScreenAnalyticsDI,
} from '@atlassian/jira-product-analytics-bridge';

import {
	Redirect as RedirectDI,
	useQueryParam as useQueryParamDI,
} from '@atlassian/react-resource-router';

import type { QuickSearchToGlobalIssueNavigatorRedirectProps } from './types.tsx';

export const QuickSearchToGlobalIssueNavigatorRedirect = ({
	Redirect = RedirectDI,
	fireScreenAnalytics = fireScreenAnalyticsDI,
	useAnalyticsEvents = useAnalyticsEventsDI,
	useCurrentRoute = useCurrentRouteDI,
	useQueryParam = useQueryParamDI,
}: QuickSearchToGlobalIssueNavigatorRedirectProps): React.JSX.Element => {
	const route = useCurrentRoute();

	const [searchString] = useQueryParam('searchString');

	const { createAnalyticsEvent } = useAnalyticsEvents();
	// eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
	useEffect(() => {
		if (!route) return;

		const screenEvent = createAnalyticsEvent({
			screenName: 'quickSearchRedirect',
			attributes: {
				type: route.name,
			},
		});
		fireScreenAnalytics(screenEvent);
	}, [createAnalyticsEvent, fireScreenAnalytics, route]);

	const jql: string =
		searchString != null ? `textfields ~ "${searchString}"` : 'ORDER BY created DESC';

	const redirectUrl = `/issues/?jql=${encodeURIComponent(jql)}`;

	return <Redirect to={redirectUrl} />;
};

const JiraGlobalIssueNavigatorRedirect = (): React.JSX.Element => (
	<QuickSearchToGlobalIssueNavigatorRedirect />
);

export default JiraGlobalIssueNavigatorRedirect;
